import React from 'react';
import { Box, ChevronDownIcon } from '@razorpay/blade/components';
import { ConnectorLine } from './styles';

const ConnectorWithArrow = () => (
  <Box display="flex" flexDirection="column" alignItems="center" marginY="spacing.1">
    <ConnectorLine />
    <ChevronDownIcon size="small" color="surface.icon.gray.muted" />
  </Box>
);

export { ConnectorWithArrow };
